import request from '@/utils/request'

/**
 *GET /api/adv/qryAdvInfo 查询广告位内容
 * @param {*} params
 * @returns
 */
export function qryAdvInfo(params) {
  return request({
    url: '/api/adv/qryAdvInfo',
    method: 'get',
    params
  })
}

/**
 *POST /api/adv/addAdvInfo 添加广告
 * @param {*} data
 * @returns
 */
export function addAdvInfo(data) {
  return request({
    url: '/api/adv/addAdvInfo',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/modAdvInfo 编辑广告
 * @param {*} data
 * @returns
 */
export function modAdvInfo(data) {
  return request({
    url: '/api/adv/modAdvInfo',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/activeStopAdv 启用禁用广告
 * @param {*} data
 * @returns
 */
export function activeStopAdv(data) {
  return request({
    url: '/api/adv/activeStopAdv',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/delAdvInfo 删除广告
 * @param {*} data
 * @returns
 */
export function delAdvInfo(data) {
  return request({
    url: '/api/adv/delAdvInfo',
    method: 'post',
    data
  })
}

/**
 *GET /api/adv/qryGroupInfo 查询计划
 * @param {*} params
 * @returns
 */
export function qryGroupInfo(params) {
  return request({
    url: '/api/adv/qryGroupInfo',
    method: 'get',
    params
  })
}

/**
 *POST /api/adv/addGroupInfo 添加计划
 * @param {*} data
 * @returns
 */
export function addGroupInfo(data) {
  return request({
    url: '/api/adv/addGroupInfo',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/modGroupInfo 编辑计划
 * @param {*} data
 * @returns
 */
export function modGroupInfo(data) {
  return request({
    url: '/api/adv/modGroupInfo',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/activeStopGroup 启用禁用计划
 * @param {*} data
 * @returns
 */
export function activeStopGroup(data) {
  return request({
    url: '/api/adv/activeStopGroup',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/delGroupInfo 删除计划
 * @param {*} data
 * @returns
 */
export function delGroupInfo(data) {
  return request({
    url: '/api/adv/delGroupInfo',
    method: 'post',
    data
  })
}

/**
 *GET /api/adv/qryAdvGroupInfo 查询广告分组
 * @param {*} parmas
 * @returns
 */
export function qryAdvGroupInfo(params) {
  return request({
    url: '/api/adv/qryAdvGroupInfo',
    method: 'get',
    params
  })
}

/**
 *POST /api/adv/addAdvGroupInfo 添加广告分组
 * @param {*} data
 * @returns
 */
export function addAdvGroupInfo(data) {
  return request({
    url: '/api/adv/addAdvGroupInfo',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/batchAddAdvGroupInfo 批量添加分组广告
 * @param {*} data
 * @returns
 */
export function batchAddAdvGroupInfo(data) {
  return request({
    url: '/api/adv/batchAddAdvGroupInfo',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/modAdvGroupInfo 编辑广告分组
 * @param {*} data
 * @returns
 */
export function modAdvGroupInfo(data) {
  return request({
    url: '/api/adv/modAdvGroupInfo',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/delAdvGroupInfo 删除广告分组
 * @param {*} data
 * @returns
 */
export function delAdvGroupInfo(data) {
  return request({
    url: '/api/adv/delAdvGroupInfo',
    method: 'post',
    data
  })
}

/**
 *GET /api/adv/qryDeviceGroupInfo 查询设备广告分组
 * @param {*} params
 * @returns
 */
export function qryDeviceGroupInfo(params) {
  return request({
    url: '/api/adv/qryDeviceGroupInfo',
    method: 'get',
    params
  })
}

/**
 *GET /api/adv/qryDeviceInfo 查询设备信息
 * @param {*} params
 * @returns
 */
export function qryDeviceInfo(params) {
  return request({
    url: '/api/adv/qryDeviceInfo',
    method: 'get',
    params
  })
}

/**
 *POST /api/adv/addDeviceGroupInfo 添加设备广告分组
 * @param {*} data
 * @returns
 */
export function addDeviceGroupInfo(data) {
  return request({
    url: '/api/adv/addDeviceGroupInfo',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/batchAddDeviceGroupInfo 批量添加设备广告分组
 * @param {*} data
 * @returns
 */
export function batchAddDeviceGroupInfo(data) {
  return request({
    url: '/api/adv/batchAddDeviceGroupInfo',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/modDeviceGroupInfo 编辑设备广告分组
 * @param {*} data
 * @returns
 */
export function modDeviceGroupInfo(data) {
  return request({
    url: '/api/adv/modDeviceGroupInfo',
    method: 'post',
    data
  })
}

/**
 *POST /api/adv/delDeviceGroupInfo 删除设备广告分组
 * @param {*} data
 * @returns
 */
export function delDeviceGroupInfo(data) {
  return request({
    url: '/api/adv/delDeviceGroupInfo',
    method: 'post',
    data
  })
}

/**
 *GET /api/adv/qryAdvPlayHistory 查询设备播放记录(按小时统计播放次数和时长)
 * @param {*} params
 * @returns
 */
export function qryAdvPlayHistory(params) {
  return request({
    url: '/api/adv/qryAdvPlayHistory',
    mehtod: 'get',
    params
  })
}

/**
 *POST /api/adv/syncAdvToDev 控制下发广告
 * @param {*} data
 * @returns
 */
export function syncAdvToDev(data) {
  return request({
    url: '/api/adv/syncAdvToDev',
    method: 'post',
    data
  })
}
